var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "alert-success d-flex justify-content-between align-items-center",
    },
    [
      _c(
        "button",
        {
          staticClass: "btn btn-link",
          attrs: { disabled: _vm.current_index <= 0 },
          on: {
            click: function ($event) {
              return _vm.goToItem(-1)
            },
          },
        },
        [_vm._v("< Prev")]
      ),
      _vm._v(" "),
      _c("span", [
        _vm._v(
          "\n    Current Locus: " +
            _vm._s(_vm.current_region_display) +
            " -\n    "
        ),
        _vm.current_index !== null
          ? _c("span", [
              _vm._v(
                "\n      (" +
                  _vm._s(_vm.current_index + 1) +
                  " of " +
                  _vm._s(_vm.regions.length) +
                  ") -\n    "
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-link p-0 border-0 align-bottom",
            attrs: { title: "Cancel navigation" },
            on: { click: _vm.cancelNavigation },
          },
          [_vm._v("cancel batch mode")]
        ),
      ]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-link",
          attrs: {
            disabled:
              _vm.current_index !== null &&
              _vm.current_index >= _vm.regions.length - 1,
          },
          on: {
            click: function ($event) {
              return _vm.goToItem(+1)
            },
          },
        },
        [_vm._v("Next >")]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }